import script from "./sw-item-viewer-file.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-viewer-file.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-viewer-file.vue?vue&type=style&index=0&id=d602f1ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d602f1ce"]])

export default __exports__